/**
 * Мелочи оформления заказа, вынесенные из `Checkout`.
 *
 * Чистые функции без состояния: их удобно проверять и не нужно перечитывать
 * вместе с экраном.
 */
import type { PublicProduct } from '@arbuz/shared';

export function estimateWeight(
  lines: { product_id: number; qty: number }[],
  products: Map<number, PublicProduct>,
): { min: number; max: number } | null {
  let min = 0;
  let max = 0;
  let hasAny = false;

  for (const line of lines) {
    const product = products.get(line.product_id);
    if (!product) continue;
    const productMin = Number(product.weight_min_kg);
    const productMax = Number(product.weight_max_kg);
    if (!Number.isFinite(productMin) || !Number.isFinite(productMax)) continue;
    min += productMin * line.qty;
    max += productMax * line.qty;
    hasAny = true;
  }

  return hasAny ? { min, max } : null;
}

/**
 * Ключ идемпотентности.
 *
 * Витрина входит в него обязательно: одинаковый состав и слот у РАЗНЫХ
 * исполнителей дали бы один ключ, и второй заказ вернул бы чужой первый.
 */
export function idempotencyKey(
  vendorId: number,
  lines: { product_id: number; qty: number }[],
  date: string,
  start: string,
) {
  const body = lines
    .map((line) => `${line.product_id}x${line.qty}`)
    .sort()
    .join('_');
  return `v${vendorId}_${date}_${start}_${body}`.slice(0, 120);
}

export function formatDay(iso: string, locale: string): string {
  const date = new Date(`${iso}T00:00:00`);
  return date.toLocaleDateString(locale === 'uz' ? 'uz-UZ' : 'ru-RU', {
    day: 'numeric',
    month: 'long',
    weekday: 'short',
  });
}
